import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

import { signIn, signUp, signOut } from '../../store/modules/auth.module'
import { createReview } from '../../store/modules/tools.module'
import { AuthForm, ReviewForm } from '../../components'
import './ReviewOverlay.sass'


class ReviewOverlay extends Component {
  state = {
    isSignInMode: true
  }

  constructor() {
    super()
    this._toggleSignInMode = this.toggleSignInMode.bind(this)
  }

  toggleSignInMode() {
    this.setState({ isSignInMode: !this.state.isSignInMode })
  }

  renderModeToggle(isSignInMode) {
    return isSignInMode ?
      <p>
        <span>Don't have an account?</span>
        <button
          type="button"
          className="btn-transparent-sm"
          onClick={this._toggleSignInMode}
        >
          Sign up
        </button>
      </p>
    :
      <p>
        <span>Already have an account?</span>
        <button
          type="button"
          className="btn-transparent-sm"
          onClick={this._toggleSignInMode}
        >
          Sign in
        </button>
      </p>
  }

  renderSignOut() {
    return (
      <p>
        <span>Not {this.props.currentUser.email}?</span>
        <button
          type="button"
          className="btn-transparent-sm"
          onClick={this.props.signOut}
        >
          Sign in as another user
        </button>
      </p>
    )
  }

  render() {
    const { isSignInMode } = this.state
    const { toggleReviewOverlay, isVisible, currentUser, serverErrorMsg, currentTool } = this.props

    return (
      <div className={`review-overlay overlay-slidedown ${isVisible && 'open'}`}>
        <div className="menu-section">
          <button className="close-btn" onClick={toggleReviewOverlay}>&#10005;</button>
          { currentUser ? this.renderSignOut() : this.renderModeToggle(isSignInMode)}
        </div>
        <div className="review-overlay-content">
          { currentUser ?
              <ReviewForm
                submitReview={this.props.createReview}
                toolId={_.get(currentTool.data, ['id'])}
                toggleReviewOverlay={toggleReviewOverlay}
              /> :
              <AuthForm
                serverErrorMsg={serverErrorMsg}
                isVisible={isVisible}
                signIn={this.props.signIn}
                signUp={this.props.signUp}
                isSignInMode={isSignInMode}
              />
          }
        </div>
      </div>
    )
  }
}

ReviewOverlay.propTypes = {
  toggleReviewOverlay: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  signIn: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  serverErrorMsg: PropTypes.string,
  createReview: PropTypes.func
}

const mapStateToProps = ({ auth, tools }) => ({
  currentUser: auth.currentUser,
  serverErrorMsg: auth.serverErrorMsg,
  currentTool: tools.currentTool
})

export default connect(mapStateToProps, { signIn, signUp, signOut, createReview })(ReviewOverlay)
